/*global angular*/

angular.module('clinkManager').controller('CLinkURLDecoder', ['$scope', 'AppHelper', 'ngDialog', '$uibModalInstance', '$q', function ($scope, AppHelper, ngDialog, $uibModalInstance, $q) {
	
	$scope.clink = {
		url : null,
		clinkID : null,
		publisherID : null,
		siteID : null,
		message : null
	};
	
	$scope.cancel = function () {
	  	$uibModalInstance.dismiss('cancel');
  	};
  	
  	$scope.decodeURL = function() {
  		$scope._decodeURL().then( function() {} );
  	};
  	
  	$scope._decodeURL = function() {
		$scope.decodingURL = true;
		var deferred = $q.defer();
		AppHelper.getDecodedClinkIDs( {'clinkURL':$scope.clink.url},
			function( data ) {
				$scope.clink.clinkID = data['clinkID'];
				$scope.clink.publisherID = data['publisherID'];
				$scope.clink.siteID = data['siteID'];
				$scope.clink.message = data['message'];
			},
			function() {
				deferred.reject();
				$scope.message = 'Error decoding cLink URL';
				ngDialog.open({
					template: 'static/dialogs/error.html',
					scope: $scope
				});
			},
			function() {
				$scope.decodingURL = false;
				deferred.resolve();
			}
		);
		return deferred.promise;
	};
	
  	$scope.urlDecoded = function() {
  		if ( $scope.clink.clinkID ) {
  			return true;
  		}
  	    return false;
  	};	
}]);
